import {$$, getParentElementByTagName, hide, show} from "../../core/js/Dom.ts";

document.addEventListener('DOMContentLoaded', () => {
    $$('[data-aide-filter]').forEach((button) => {
        button.addEventListener('click', filtrerAide)
        document.addEventListener('aide:loaded', handleTabSwitch)
    })
})

function handleTabSwitch() {
    const filtresCourant: string[] = []
    $$('[data-aide-filter]').forEach((element: HTMLElement) => {
        if(element.getAttribute('aria-pressed') === "false") {
            filtresCourant.push(element.getAttribute('data-aide-filter')!)
        }
    })
    filtresCourant.forEach(theme => toggleTheme(theme))
}

function filtrerAide(event: DOMEvent<HTMLButtonElement>) {
    const button = getParentElementByTagName(event.target, 'button')
    const isSelected = button?.getAttribute('aria-pressed') === "true"
    const theme = button?.getAttribute('data-aide-filter')
    if(theme) {
        if(isSelected) toggleTheme(theme)
        else toggleTheme(theme, false)
    }
}

function toggleTheme(theme: string, themeIsVisible: boolean = true) {
    $$(`[data-aide-theme='${theme}']`).forEach(section => {
        if(themeIsVisible) hide(section)
        else show(section)
    })
}